function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("clipPath", {
  id: "p.0"
}, React.createElement("path", {
  d: "m0 0l500.0 0l0 500.0l-500.0 0l0 -500.0z",
  clipRule: "nonzero"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m0 0l500.0 0l0 500.0l-500.0 0z",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m103.291336 8.26378l0 0c0 -0.0013504028 0.0010986328 -0.002445221 0.0024490356 -0.002445221l293.41486 0.002445221c6.713867E-4 0 0.0012817383 2.5749207E-4 0.001739502 7.162094E-4c4.5776367E-4 4.5871735E-4 7.324219E-4 0.001080513 7.324219E-4 0.0017290115l-0.0024719238 414.8007c0 0.0013427734 -0.0010681152 0.0024414062 -0.0024414062 0.0024414062l-293.41486 -0.0024414062l0 0c-0.0013504028 0 -0.0024414062 -0.0010986328 -0.0024414062 -0.0024414062z",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m103.291336 8.26378l0 0c0 -0.0013504028 0.0010986328 -0.002445221 0.0024490356 -0.002445221l293.41486 0.002445221c6.713867E-4 0 0.0012817383 2.5749207E-4 0.001739502 7.162094E-4c4.5776367E-4 4.5871735E-4 7.324219E-4 0.001080513 7.324219E-4 0.0017290115l-0.0024719238 414.8007c0 0.0013427734 -0.0010681152 0.0024414062 -0.0024414062 0.0024414062l-293.41486 -0.0024414062l0 0c-0.0013504028 0 -0.0024414062 -0.0010986328 -0.0024414062 -0.0024414062z",
  fillRule: "evenodd"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m138.31496 35.20866l223.37007 0l0 353.44882l-223.37007 0z",
  fillRule: "evenodd"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 3,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m138.31496 35.20866l223.37007 0l0 353.44882l-223.37007 0z",
  fillRule: "evenodd"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m371.43396 152.6459l0 0c0 -3.8123322 3.0904846 -6.902817 6.9028015 -6.902817l0 0l0 0c1.8307495 0 3.5865173 0.72724915 4.8810425 2.0217896c1.2945251 1.2945251 2.0217896 3.0502777 2.0217896 4.881027l0 41.308884c0 3.812317 -3.0904846 6.902817 -6.902832 6.902817l0 0l0 0c-3.812317 0 -6.9028015 -3.0904999 -6.9028015 -6.902817z",
  fillRule: "evenodd"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m371.43396 152.6459l0 0c0 -3.8123322 3.0904846 -6.902817 6.9028015 -6.902817l0 0l0 0c1.8307495 0 3.5865173 0.72724915 4.8810425 2.0217896c1.2945251 1.2945251 2.0217896 3.0502777 2.0217896 4.881027l0 41.308884c0 3.812317 -3.0904846 6.902817 -6.902832 6.902817l0 0l0 0c-3.812317 0 -6.9028015 -3.0904999 -6.9028015 -6.902817z",
  fillRule: "evenodd"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m374.5061 154.81085l0 0c0 -2.1153564 1.7150574 -3.8302002 3.830658 -3.8302002l0 0c1.0159607 0 1.9903259 0.40353394 2.7087097 1.1218414c0.7183838 0.7183075 1.1219788 1.6925354 1.1219788 2.7083588l0 0c0 2.1153717 -1.7150574 3.8302155 -3.8306885 3.8302155l0 0c-2.1156006 0 -3.830658 -1.7148438 -3.830658 -3.8302155z",
  fillRule: "evenodd"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m374.5061 154.81085l0 0c0 -2.1153564 1.7150574 -3.8302002 3.830658 -3.8302002l0 0c1.0159607 0 1.9903259 0.40353394 2.7087097 1.1218414c0.7183838 0.7183075 1.1219788 1.6925354 1.1219788 2.7083588l0 0c0 2.1153717 -1.7150574 3.8302155 -3.8306885 3.8302155l0 0c-2.1156006 0 -3.830658 -1.7148438 -3.830658 -3.8302155z",
  fillRule: "evenodd"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  d: "m374.5061 191.6255l0 0c0 -2.1153717 1.7150574 -3.8302155 3.830658 -3.8302155l0 0c1.0159607 0 1.9903259 0.4035492 2.7087097 1.1218414c0.7183838 0.7183075 1.1219788 1.6925354 1.1219788 2.708374l0 0c0 2.1153564 -1.7150574 3.8302002 -3.8306885 3.8302002l0 0c-2.1156006 0 -3.830658 -1.7148438 -3.830658 -3.8302002z",
  fillRule: "evenodd"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m374.5061 191.6255l0 0c0 -2.1153717 1.7150574 -3.8302155 3.830658 -3.8302155l0 0c1.0159607 0 1.9903259 0.4035492 2.7087097 1.1218414c0.7183838 0.7183075 1.1219788 1.6925354 1.1219788 2.708374l0 0c0 2.1153564 -1.7150574 3.8302002 -3.8306885 3.8302002l0 0c-2.1156006 0 -3.830658 -1.7148438 -3.830658 -3.8302002z",
  fillRule: "evenodd"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m374.5061 173.21819l0 0c0 -2.1153717 1.7150574 -3.8302155 3.830658 -3.8302155l0 0c1.0159607 0 1.9903259 0.40353394 2.7087097 1.1218414c0.7183838 0.7183075 1.1219788 1.6925354 1.1219788 2.708374l0 0c0 2.1153564 -1.7150574 3.8302002 -3.8306885 3.8302002l0 0c-2.1156006 0 -3.830658 -1.7148438 -3.830658 -3.8302002z",
  fillRule: "evenodd"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m374.5061 173.21819l0 0c0 -2.1153717 1.7150574 -3.8302155 3.830658 -3.8302155l0 0c1.0159607 0 1.9903259 0.40353394 2.7087097 1.1218414c0.7183838 0.7183075 1.1219788 1.6925354 1.1219788 2.708374l0 0c0 2.1153564 -1.7150574 3.8302002 -3.8306885 3.8302002l0 0c-2.1156006 0 -3.830658 -1.7148438 -3.830658 -3.8302002z",
  fillRule: "evenodd"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m376.80704 173.21819l0 0c0 -0.8447571 0.6848755 -1.5295563 1.5297241 -1.5295563l0 0c0.4057312 0 0.7948303 0.16114807 1.0816956 0.44799805c0.28689575 0.28683472 0.44805908 0.67588806 0.44805908 1.0815582l0 0c0 0.8447418 -0.6848755 1.529541 -1.5297546 1.529541l0 0c-0.84484863 0 -1.5297241 -0.6847992 -1.5297241 -1.529541z",
  fillRule: "evenodd"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m376.80704 173.21819l0 0c0 -0.8447571 0.6848755 -1.5295563 1.5297241 -1.5295563l0 0c0.4057312 0 0.7948303 0.16114807 1.0816956 0.44799805c0.28689575 0.28683472 0.44805908 0.67588806 0.44805908 1.0815582l0 0c0 0.8447418 -0.6848755 1.529541 -1.5297546 1.529541l0 0c-0.84484863 0 -1.5297241 -0.6847992 -1.5297241 -1.529541z",
  fillRule: "evenodd"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#000000",
  fillOpacity: 0,
  d: "m105.637794 423.0748l288.72443 0l0 68.66141l-288.72443 0z",
  fillRule: "evenodd"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  stroke: "#000000",
  strokeWidth: 4,
  strokeLinejoin: "round",
  strokeLinecap: "butt",
  d: "m105.637794 423.0748l288.72443 0l0 68.66141l-288.72443 0z",
  fillRule: "evenodd"
});

var SvgWindows = function SvgWindows(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0.0 0.0 500.0 500.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWindows, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/windows.cc3f3380.svg";
export { ForwardRef as ReactComponent };